import { render } from "./DigestId.vue?vue&type=template&id=ca308e8a&scoped=true&ts=true"
import script from "./DigestId.vue?vue&type=script&lang=ts"
export * from "./DigestId.vue?vue&type=script&lang=ts"

import "./DigestId.vue?vue&type=style&index=0&id=ca308e8a&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca308e8a"]])

export default __exports__